export default function CostPlanningGuide() {
  const guides = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'How much does landscaping cost in Glen Mills?',
      description: 'Professional landscaping projects in Delaware County typically range from $15,000 to $75,000+ depending on scope. Custom patios start around $20,000, retaining walls from $8,000, and complete outdoor living transformations from $50,000+.'
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Typical project ranges for patios, lighting, and hardscaping',
      description: 'Paver patios: $20,000-$45,000 • Outdoor kitchens: $25,000-$60,000 • Retaining walls: $8,000-$30,000 • Landscape lighting: $5,000-$15,000 • Drainage solutions: $3,000-$12,000 • Complete designs: $50,000-$150,000+'
    },
    {
      icon: 'ri-scales-line',
      title: 'What factors affect landscaping project pricing?',
      description: 'Project size and complexity, material selection (natural stone vs. pavers), site accessibility, grading requirements, drainage needs, lighting integration, outdoor kitchen features, and custom design elements all influence final investment.'
    },
    {
      icon: 'ri-roadmap-line',
      title: 'How to plan a backyard outdoor living project',
      description: 'Start with a consultation to discuss your vision and budget. We assess your property, create a custom design, provide detailed estimates, and guide you through material selection. Projects typically take 2-6 weeks from design approval to completion.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-16">
          <div className="text-[#E67E22] text-sm font-semibold tracking-wider uppercase mb-3">Investment Guide</div>
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Landscaping Project Cost Guide</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Understanding project costs and planning your outdoor living transformation
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {guides.map((guide, index) => (
            <div key={index} className="bg-[#F8F8F8] rounded-2xl p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-[#E67E22] rounded-xl mb-6">
                <i className={`${guide.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 leading-tight">{guide.title}</h3>
              <p className="text-gray-600 leading-relaxed">{guide.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-[#FFF8F0] border-l-4 border-[#E67E22] rounded-lg p-8 max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 leading-relaxed">
              <strong className="text-gray-900">Ready to discuss your project?</strong> Every property is unique. Schedule a free consultation to receive a detailed estimate tailored to your specific outdoor living goals and site conditions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}